import React, { useState, createContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import ReactGA from "react-ga";

const AuthContext = createContext();
const { Provider } = AuthContext;
const TRACKING_ID = "UA-23405765-9"; // TRACKING_ID
ReactGA.initialize(TRACKING_ID);

const AuthProvider = ({ children }) => {
  const history = useHistory();
  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
    return () => {};
  });

  const [schoolInfo, setSchoolInfo] = useState(null);
  const [forgotPswrd, setForgotPswrd] = useState(null);
  const [studentVideos, setStudentVideos] = useState([]);
  const [isExamOngoing, setIsExamOngoing] = useState(false);
  const [toggleMobileChat, setToggleMobileChat] = useState(false);

  const baseUrl = "https://devapi.edves.net/studentapi/public/v1";

  // const token = localStorage.getItem('token');
  //   const userInfo = localStorage.getItem('userInfo');

  const studentDetails = localStorage.getItem("studentInfo");
  const schoolDomain = localStorage.getItem("schoolDomain");
  const subSchoolData = localStorage.getItem("subSchoolData");
  const schoolInfoLS = localStorage.getItem("schoolInfo");
  const studentInfoLS = JSON.parse(localStorage.getItem("studentInfo"));

  const [studentInfo, setStudentInfo] = useState({
    studentDetails: studentDetails ? JSON.parse(studentDetails) : {},
  });

  const setAuthInfo = (info) => {
    if (
      localStorage.getItem(
        "studentInfo" === null || "studentInfo" === undefined
      )
    ) {
      localStorage.setItem("studentInfo", JSON.stringify(info));
    } else {
      localStorage.setItem("studentInfo", JSON.stringify(info));
    }
    setStudentInfo(info);
  };

  //   const expiresAt = localStorage.getItem('expiresAt');
  //   const [authState, setAuthState] = useState({
  //     token: null,
  //     expiresAt,
  //     userInfo: userInfo ? JSON.parse(userInfo) : {}
  //   })

  //   const setAuthInfo = ({ token, userInfo, expiresAt }) => {
  //     localStorage.setItem('token', token);
  //     localStorage.setItem('userInfo', JSON.stringify(userInfo));
  //     localStorage.setItem('expiresAt', expiresAt);
  //     setAuthState({
  //       token,
  //       userInfo,
  //     expiresAt
  //     })
  //   }

  const logout = () => {
    localStorage.clear();
    localStorage.setItem("schoolDomain", schoolDomain);
    localStorage.setItem("subSchoolData", subSchoolData);
    localStorage.setItem("schoolInfo", schoolInfoLS);
    // localStorage.setItem('studentInfo', studentInfoLS);

    // setAuthState({
    //   token: null,
    //   userInfo: {},
    //   expiresAt: null
    // })
    history.push(`/students/login`);
    window.location.reload();
    // if(window.location.host === 'demo.edves.net') {
    //   history.push(`/students`);
    // } else {
    //   history.push(`/students/login`);
    //   window.location.reload();
    // }
  };

  return (
    <Provider
      value={{
        setSchoolInfo,
        schoolInfo,
        setForgotPswrd,
        forgotPswrd,
        setStudentInfo: (info) => setAuthInfo(info),
        studentInfo,
        setStudentVideos,
        studentVideos,
        baseUrl,
        setIsExamOngoing,
        isExamOngoing,
        logout,
        toggleMobileChat,
        setToggleMobileChat,
      }}>
      {children}
    </Provider>
  );
};

export { AuthContext, AuthProvider };
